
import Vue from 'vue'
import BaseButton from './BaseButton.vue'
export default Vue.extend({
   name: 'SaveButton',
   props: {
      label: { default: 'New', type: String },
      actionLabel: { default: 'Creating', type: String },
      showIcon: { default: true, type: Boolean },
      icon: { default: 'glyphicon-plus', type: String },
      type: { default: 'btn-default', type: String },
      size: { default: 'btn-sm', type: String },
      enabled: { default: true, type: Boolean },
      adding: { default: false, type: Boolean },
   },
   components: {
      BaseButton,
   },
})
